Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = render;

var _icon = require("@clayui/icon");

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */
let counter = 0;
/**
 * Wrapper for ReactDOM render that automatically:
 *
 * - Provides commonly-needed context (for example, the Clay spritemap).
 * - Unmounts when portlets are destroyed based on the received
 *   `portletId` value inside `renderData`. If none is passed, the
 *   component will be automatically unmounted before the next navigation.
 *
 * @param {Function|React.Element} renderable Component, or function that returns an Element, to be rendered.
 * @param {object} renderData Data to be passed to the component as props.
 * @param {HTMLElement} container DOM node where the component is to be mounted.
 *
 * The React docs advise not to rely on the render return value, so we
 * don't propagate it.
 *
 * @see https://reactjs.org/docs/react-dom.html#render
 */

function render(renderable, renderData, container) {
  if (!window.Liferay.SPA || window.Liferay.SPA.app) {
    const {
      portletId
    } = renderData; // Temporary workaround until frontend-icons-web is converted to ESM.
    // We will replace with an import from frontend-icons-web later.

    const spritemap = (Liferay.Icons || {}).spritemap;
    let {
      componentId
    } = renderData;
    const destroyOnNavigate = !portletId;

    if (!componentId) {
      componentId = "__UNNAMED_COMPONENT__".concat(portletId, "__").concat(counter++);
    }

    window.Liferay.component(componentId, {
      destroy: () => {
        container.classList.remove('lfr-tooltip-scope');

        _reactDom.default.unmountComponentAtNode(container);
      }
    }, {
      destroyOnNavigate,
      portletId
    });
    const Component = typeof renderable === 'function' || renderable.$$typeof === Symbol.for('react.forward_ref') ? renderable : null;
    container.classList.add('lfr-tooltip-scope'); // eslint-disable-next-line @liferay/portal/no-react-dom-render

    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_icon.ClayIconSpriteContext.Provider, {
      value: spritemap
    }, Component ? /*#__PURE__*/_react.default.createElement(Component, renderData) : renderable), container);
  } else {
    window.Liferay.once('SPAReady', () => {
      render(renderable, renderData, container);
    });
  }
}